import React from 'react';
import T from 'i18n-react';
import './CallToActionModal.css'
import { useSelector } from 'react-redux';
import PlainButton from '../../Controls/plainButton';

const CallToActionModal = (props) => {
    const lang = useSelector(state => state.layout.lang);
    
    return (
        <div className='call-to-action-modal'>
            {props.headerTitle && 
            <div className='call-to-action-modal-header'>
                {T.translate(props.headerTitle)}
            </div>
            }
            {props.children}
            {props.footerTitle && 
            <div className='call-to-action-modal-footer'>
                <div className='call-to-action-modal-footer-label'>
                    {T.translate(props.footerTitle)}
                </div>
                {props.footerButtonKey && <PlainButton labelKey={props.footerButtonKey}  onClick={props.footerButtonClick} />}
            </div>
            }
        </div>
    );
};

export default CallToActionModal;